import { TypeGenerator, isString, isInteger } from '../utils/type';
import { IArgumentType } from '../functions/utils';
import { InferenceError } from '../errors';
import { IFunctionToken } from '../typings/token';


// 向后截取字符串函数
// 函数需要为两个参数
// 参数1: 需要截取的目标字符串
// 参数2: 需要截取的开始索引值
export function SUBSTR_AFTER(args: IArgumentType[], token: IFunctionToken) {
  const functionName = token.formatName;

  if (args.length !== 2) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的参数必须为两个`, token.position);
  }

  if (!isString(args[0], false)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的第一个参数必须为 字符串 类型`, token.position);
  }

  if (!isInteger(args[1], false)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的第二个参数必须为整数类型`, token.position);
  }

  return TypeGenerator.String();
}
